import type { TExpenseStatusType } from 'api/swagger';

export type { TExpenseStatusType } from 'api/swagger';

export const ExpenseStatus: Record<string, TExpenseStatusType> = {
  Waiting: 'waiting',
  Problem: 'problem',
  Completed: 'completed',
  Cancelled: 'cancelled',
};

export const ExpenseStatuses: TExpenseStatusType[] = [
  ExpenseStatus.Waiting,
  ExpenseStatus.Problem,
  ExpenseStatus.Completed,
  ExpenseStatus.Cancelled,
];
